<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>공영주차장</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">공영주차장</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">주차장 이용안내</p>
          <ul class="depth">
            <li><router-link to="/map" title="노외주차장 검색">노외주차장 검색</router-link></li>
            <li><router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link></li>
            <li><router-link to="/parkfeereduction" title="주차요금 감면안내">주차요금 감면안내</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <article>
          <div class="infoBox notice">
            <div class="parking">
              <img src="../../../assets/images/ico/ico-parking-logo.svg" alt="" />
              <div class="parkBox">
                <div class="notice">
                  <h2>주차장 운영근거</h2>
                  <a class="btn" @click="openLaw">이천시 주차장 조례보러가기</a>
                </div>
                <p>
                  이천시시설공단 공영주차장은 주차장법 및 이천시 주차장 조례에 의거하여 이천시 주차질서 확립과<span
                >시민편의 증진을 목적으로 운영하고 있습니다.</span
                >
                </p>
              </div>
            </div>
          </div>
        </article>
        <h3 class="pageTitle">주차장 이용안내</h3>
        <article>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table parking-using-table">
              <table>
                <caption>
                  주차장 이용안내 테이블 표
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: auto" />
                </colgroup>
                <thead>
                <tr>
                  <th scope="col" class="purple" colspan="2" rowspan="2">구분</th>
                  <th scope="col" class="purple" colspan="2">운영시간</th>
                  <th scope="col" class="purple" colspan="3">이용요금(단위 : 원)</th>
                </tr>
                <tr>
                  <th class="morelightPurple">평일</th>
                  <th class="morelightPurple">토,일요일 및 공휴일</th>
                  <th class="morelightPurple">1회 (1구획 최초 30분)</th>
                  <th class="morelightPurple">30분 초과 시 <br />10분마다</th>
                  <th class="morelightPurple">일 최대 요금</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row" rowspan="2">노상주차장<br />(1급지)</th>
                  <td>31구간</td>
                  <td>
                    9:00~18:00<br />
                    (유료운영)
                  </td>
                  <td>무료운영</td>
                  <td>600</td>
                  <td>250</td>
                  <td>7,000</td>
                </tr>
                <tr>
                  <td>터미널(8-2)</td>
                  <td rowspan="9" colspan="2">00:00 ~ 24:00<br />(유료운영)</td>
                  <td>600</td>
                  <td>250</td>
                  <td>7,000</td>
                </tr>
                <tr>
                  <th scope="row" rowspan="3">
                    노외주차장<br />
                    (1급지)
                  </th>
                  <td>중리천로</td>
                  <td>600</td>
                  <td>250</td>
                  <td>7,000</td>
                </tr>
                <tr>
                  <td>창전동 임시공영주차장</td>
                  <td>최초 30분 무료</td>
                  <td>250<br />(30분 초과시 10분마다)</td>
                  <td>7,000</td>
                </tr>
                <tr>
                  <td>남천상가</td>
                  <td>최초 30분 무료</td>
                  <td>250<br />(30분 초과시 10분마다)</td>
                  <td>7,000</td>
                </tr>
                <tr>
                  <th scope="row" rowspan="4">노외주차장<br />(2급지)</th>
                  <td>북샛말,사동리 주차장</td>
                  <td>500</td>
                  <td>200</td>
                  <td>5,000</td>
                </tr>
                <tr>
                  <td>공설운동장</td>
                  <td>최초 30분 무료</td>
                  <td>200<br />(30분 초과시 10분마다)</td>
                  <td>5,000</td>
                </tr>
                <tr>
                  <td>마장 1, 2 주차장</td>
                  <td>최초 1시간 무료</td>
                  <td>200<br />(1시간 초과시 10분마다)</td>
                  <td>5,000</td>
                </tr>
                <tr>
                  <td>서희 청소년문화센터</td>
                  <td>최초 2시간 무료</td>
                  <td>200<br />(2시간 초과시 10분마다)</td>
                  <td>5,000</td>
                </tr>
                <tr>
                  <th scope="row">노외주차장<br />(3급지)</th>
                  <td>택시쉼터</td>
                  <td>최초 1시간 무료</td>
                  <td>150<br />(1시간 초과시 10분마다)</td>
                  <td>4,000</td>
                </tr>
                </tbody>
              </table>
              <p style="margin-top: 10px; font-size: 14px;">※ 주차장에 입차 후 10분까지는 무료 회차할 수 있다.</p>
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle">1회주차</p>
          <div class="infoBox">
            "이천시 주차장 설치 및 관리 조례"에 의해 최초 30분 기본요금에 초과 10분마다 요금을 적용하여 이용 후 출차 시
            주차관리원에게 납부
          </div>
          <!--          <p class="info">운영 마감 2시간 이전부터 선불로 납부 가능</p>-->
          <p class="info">입차 후 10분 이내에는 전액 환불이 가능하나 10분 초과시 환불불가</p>
          <p class="info">입차 후 출차가 되면 재입차 시, 주차요금 다시 부과</p>
          <p class="info">주차장 입차 후 10분까지는 무료주차로 처리</p>
        </article>
        <article>
          <p class="subTitle">이용거부 대상</p>
          <ol class="bullet numType">
            <li class="num01">정당한 사유없이 주차요금을 내지 아니하고 주차하는 경우</li>
            <li class="num02">자동차의 구조상 주차가 불가능하거나 곤란한 경우</li>
            <li class="num03">발화성 또는 인화성 물질을 적재한 차량</li>
            <li class="num04">주차장의 구조설비를 손상할 우려가 있는 차량</li>
            <li class="num05">주차장 안에서 자동차를 이용하여 영업행위를 하는 경우</li>
            <li class="num06">주차장을 주차장 외의 목적으로 이용하는 경우</li>
          </ol>
        </article>
        <article>
          <p class="subTitle">방치차량에 대한 조치(이천시 주차장 설치 및 관리 조례 제12조의4)</p>
          <ol class="bullet numType">
            <li class="num01">시장은 공영(노상주차장 및 노외주차장의 경우에는 주차요금을 징수하지 않는 경우에 한한다)주차장에
              <br>특별한 사유 없이 1개월(자동차가 분해·파손되어 운행이 불가능한 경우에는 15일) 상 방치한 자동차를
              <br>견인보관소로 이동 조치할 수 있으며 견인 및 보관에 발생하는 비용은 자동차 소유주가 부담한다.</li>
            <li class="num02">방치차량을 견인하는 경우 발생하는 비용은 「이천시 견인자동차 운영에 관한 조례」 제3조를 따른다.</li>
            <li class="num03">방치차량을 보관하는 경우 발생하는 비용은 1일당 노상주차장 1급지 1일 최대 요금으로 한다.</li>
          </ol>
        </article>
        <article>
          <p class="subTitle">손해배상책임(이천시 주차장 설치 및 관리 조례 제20조의3)</p>
          <ol>
            <li>개방주차장 내에서 이용자가 고의 또는 과실로 주차장 시설물이나 다른 차량에 재산상의 손해를 입히거나 타인에게 피해를 입혔을 경우에는
              <br>그 피해를 원상복구하거나 그에 상당하는 금액을 배상하여야 한다.</li>
          </ol>
        </article>
        <article>
          <p class="subTitle">유의사항</p>
          <ul class="bullet dotType">
            <li>
              주차요금은 전액 이천시 교통사업특별회계로 입금되어 주차장 신설, 교통안전 시설물 설치 등에 쓰여집니다.
            </li>
            <li>주차요금 납부 후 영수증을 반드시 교부 받으시고 5년간 보관하시기 바랍니다.</li>
            <li>영수증을 보관하지 않으셔서 발생되는 모든 일은 이천시시설관리공단에서 책임지지 않습니다.</li>
            <li>
              주차장 이용 문의 및 불편 신고, 이의신청은 이천시시설관리공단 공영주차장 사무실(T.635-2070) / 통합관제실(T.631-2071)로 연락하여 주시기 바랍니다.
            </li>
          </ul>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {
    openLaw() {
      window.open(
        'https://www.law.go.kr/LSW//ordinInfoP.do?ordinId=2106534',
        '_blank',
      );
    },
  },
};
</script>